module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-ExtraLight.204fc7fd.otf";